var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTree = function SvgTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#28c382",
    "data-name": "Ellipse 320"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.07 43.74a10 10 0 0 1-20 0c0-5.3 2.4-25.74 10-25.74s10 20.44 10 25.74z",
    "data-name": "Path 2324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.47 36.82-4.22-15.75-8.46 31.51H34.7l-.2-.76",
    "data-name": "Path 2325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 35.25c1.87-2.45 4.47-4.19 7.33-4.19 5.73 0 10.38 7 10.38 12.68a10.38 10.38 0 0 1-18.92 5.88",
    "data-name": "Path 2326"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M26.21 41.05v21.52",
    "data-name": "Line 53"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M55.41 41.05v21.52",
    "data-name": "Line 54"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M40.05 37.21v25.36",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m23.56 44.51 2.69 2.69",
    "data-name": "Line 56"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m52.76 46.82 2.69 2.68",
    "data-name": "Line 57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m36.2 43.36 3.85 3.84",
    "data-name": "Line 58"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m59.48 48.16-4.03 3.65",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m44.11 45.09-4.03 3.65",
    "data-name": "Line 60"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m42.96 39.32-2.88 2.5",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m28.36 48.55-2.11 1.72",
    "data-name": "Line 62"
  }))))));
};
export default SvgTree;